module.exports = __webpack_public_path__ + "img/circle-j.37870df3.svg";